import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import DeactivateTeamsModal from './DeactivateTeamsModal';

export const useDeactivateTeamsModal = () => {
  const { openModal } = useDynamicModal();

  const openDeactivateTeamsModal = useCallback(
    ({
      teamTargets,
      teamNamesById,
      onAfterDeactivate,
    }: {
      teamTargets: Array<{ teamId: number; tenant: string; realmId: string }>;
      teamNamesById: Record<number, string>;
      onAfterDeactivate?: VoidFunction;
    }) => {
      openModal({
        modal: ({ toggle }) => (
          <DeactivateTeamsModal
            teamNamesById={teamNamesById}
            teamTargets={teamTargets}
            onClose={toggle}
            onAfterDeactivate={onAfterDeactivate ?? (() => {})}
          />
        ),
      });
    },
    [openModal],
  );

  return {
    openDeactivateTeamsModal,
  };
};
